<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                            </span></h2>
                </v-row>
        
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5" style="overflow-x: hidden;"
                >
                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="$t('performancemanagement.kpiset')"
                                type="text"
                                ref="code"
                                v-model="formData.code"
                                :rules="[rules.required]"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('pmkpiset.description')"
                                type="text"
                                ref="description"
                                v-model="formData.description"
                                @input="updateValue"
                                :rules="[rules.required]"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('columns.remark')"
                                type="text"
                                ref="remark"
                                v-model="formData.remark"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row v-if="isEdit">
                        <v-col cols="6" sm="6" class="blue--text">
                           {{$t('performancemanagement.kpiitems')}}
                        </v-col>
                    </v-row>

                    <v-row v-if="isEdit && !loading" style="overflow-x: auto; display: block; max-width: 100%;">
                        <app-table
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                detailItem: this.KPISetDetailsList,
                                kpisetid: this.parentObject.kpisetid
                            }"
                        />
                    </v-row>
                </v-container>


                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit
                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" 
                />

            </v-form>

        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                code: this.parentObject.data.code,
                description: this.parentObject.data.description,
                remark: this.parentObject.data.remark,
                stamp: this.parentObject.data.stamp,
                userid: this.$store.getters.userId,
            },

            targetOptionFull: [],
            targetOptionList: [],
            KPISetDetailsList: [],
            loading: true,

            errMsg: '',
            isErr: false,
            isEdit : this.parentObject.isEdit,
            search: this.parentObject.searchnew,

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('performancemanagement.goal'), value: 'goal', width: '150px', sortable: true},
                { text: this.$t('performancemanagement.kpi'), value: 'kpi', width: '150px', sortable: true},
                { text: this.$t('pmkpiset.targetoption'), value: 'targetoption', width: '150px', sortable: true},
                { text: this.$t('pmkpiset.calmethod'), value: 'calmethod', width: '180px', sortable: true},
                { text: this.$t('pmkpiset.defaultweightage'), value: 'weightage', width: '100px', sortable: true},
                { text: this.$t('pmkpiset.defaultthreshold'), value: 'threshold', width: '100px', sortable: true},
                { text: this.$t('pmkpiset.defaulttarget'), value: 'target', width: '100px', sortable: true},
                { text: this.$t('pmkpiset.defaultstretch'), value: 'stretch', width: '100px', sortable: true},
                { text: this.$t('pmkpiset.defaultsubperiodcount'), value: 'subperiodcount', width: '100px', sortable: true},
                { text: this.$t('pmkpiset.canchangeweightage'), value: 'changeWeightageText', width: '100px', sortable: true},
                { text: this.$t('pmkpiset.canchangetarget'), value: 'changeTargetText', width: '100px', sortable: true},
                { text: this.$t('pmkpiset.canchangesubperiodcount'), value: 'changeSubperiodcountText', width: '100px', sortable: true},
              
            ],

        }
    },

    methods: {

        updateValue() {
            this.$emit('input', {
                code: this.formData.code,
                description: this.formData.description,
                remark: this.formData.remark,
                stamp: this.formData.stamp,
                userid: this.formData.userid,
            });
        },

        loadKPISetDetails() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpisetd/' + this.parentObject.kpisetid })
            .then((res) => {
                vm.KPISetDetailsList = res.data.rec;
                vm.KPISetDetailsList.forEach(item => {
                    item.changeWeightageText = item.changeWeightage === 1 ? 'Y' : item.changeWeightage === 0 ? 'N' : '';
                    item.changeTargetText = item.changeTarget === 1 ? 'Y' : item.changeTarget === 0 ? 'N' : '';
                    item.changeSubperiodcountText = item.changeSubperiodcount === 1 ? 'Y' : item.changeSubperiodcount === 0 ? 'N' : '';
                });

                console.log("KPISetDetailsList", vm.KPISetDetailsList);
                vm.loading = false;
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeKPITypeHandler(id) {
            if (id === 1) {
                this.formData.description = null;
            } 

            this.updateValue();
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'kpisetlist', params: { search: this.search}});
        },
    },

    mounted() {
        this.loadKPISetDetails();
    }
    
}
</script>